
import actions from './actions'
import mutations from './mutations'

let state = {
    all: null,
    count: 0,
    current: null,
    page: 1
}

const ACTIONS = {
    ADD: 'budgets/add',
    GET: 'budgets/get',
    GET_ALL: 'budgets/getAll',
    GET_NEXT: 'budgets/getNext',
    UPDATE: 'budgets/update',
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}

export { ACTIONS as actions }